import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import {getLoginStatus} from '@/api'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/UserLogin.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to,from,next)=>{
  let status = false
  try {
    
    await getLoginStatus().then(res=>{
      status = res.data
    }).catch(()=>{
      status = false
    })
  } catch (error) {
    status = false
  }
  
    if(to.fullPath == '/' && !status){
      next({path:'/login'})
    }else if(to.fullPath == '/login' && status){
      next('/')
    }else{
      next()
    }
  })


export default router
